module.exports = __webpack_public_path__ + "static/media/globe.d994cba2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/black/globe.svg
// module id = 1391
// module chunks = 0